import { Box } from '@osmosis/tailwind-ui/components/Box';
import React, { FC } from 'react';
import './ComposerHtmlNotes.css';

type Props = {
  html: string;
  'data-testid'?: string;
  theme: string;
};

/**
 * Render raw Table data in ComposerNotes.
 */
const ComposerHtmlNotes: FC<Props> = (props) => {
  const { html, theme } = props;

  return (
    <Box
      data-testid={props['data-testid']}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      className={`text-[16px] mb-4 ${theme}-theme`}
    />
  );
};

export default ComposerHtmlNotes;
